export default "__VITE_ASSET__CppM9EGA__"